import React from 'react';
import { AlertCircle, LoaderCircle, RotateCcw } from 'lucide-react';

export default function PendingCollaborationNote({ draft, onRetry }) {
  const failed = draft.status === 'failed';
  return (
    <article className={`collab-note collab-note--${draft.status}`} aria-label={failed ? 'Failed note' : 'Sending note'}>
      <div className="collab-note__meta">
        <strong><span className="collab-note__avatar" aria-hidden="true">You</span>You</strong>
        <time dateTime={draft.createdAt}>{new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(draft.createdAt))}</time>
      </div>
      {draft.text && <p>{draft.text}</p>}
      {draft.files.length > 0 && <div className="collab-note__pending-files">{draft.files.map((file, index) => <span key={`${file.name}-${index}`}>{file.name}</span>)}</div>}
      <div className="collab-note__delivery" role="status">
        {failed ? (
          <>
            <AlertCircle size={16} aria-label="Send failed" title={draft.error} />
            <span>Failed to send</span>
            <button type="button" onClick={() => onRetry(draft.localId)} aria-label="Retry sending note" title="Retry sending"><RotateCcw size={16} /></button>
          </>
        ) : <><LoaderCircle size={16} className="collab-load-more__spinning" aria-hidden="true" /><span>Sending…</span></>}
      </div>
    </article>
  );
}
